import { ProductForm } from '../../forms/forms/product.form';
import { QuickActionConsumeForm } from '../../forms/forms/quick-action-consume.form';
import { QuickActionOpenForm } from '../../forms/forms/quick-action-open.form';
import { QuickActionTransferForm } from '../../forms/forms/quick-action-transfer.form';
import { ShoppingItemForm } from '../../forms/forms/shopping-item.form';
import { ShoppingSessionForm } from '../../forms/forms/shopping-session.form';

export class QuickActionForms {
  consume = new QuickActionConsumeForm();
  open = new QuickActionOpenForm();
  transfer = new QuickActionTransferForm();
}

class ShoppingForms {
  item = new ShoppingItemForm();
  session = new ShoppingSessionForm();
}

export class DashboardForms {
  product = new ProductForm();
  quickAction = new QuickActionForms();
  shopping = new ShoppingForms();
}
